import { z } from "zod";

export const ErrorResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
});